<template>
  <v-form v-model="valid" ref="mainForm">
    <CarteIdentification :identification="identification" class="mb-6" />
  </v-form>
</template>

<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CarteIdentification from "@/components/form_parts/CarteIdentification.vue"

export default {
  components: { CarteIdentification },
  mixins: [StepFormWithValidation],
  props: {
    sas: { type: Object }
  },
  computed: {
    identification() {
      return this.sas.identification
    }
  }
}
</script>

<style></style>
